export default __webpack_public_path__ + "static/media/trash.f9688dae.svg";